// extracted by mini-css-extract-plugin
module.exports = {"page":"jW-z","cartModal":"kW-z","checkout":"lW-z","placeholder":"mW-z","account":"nW-z"};